var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["InferenceSession"]: () => (__WEBPACK_EXTERNAL_MODULE_onnxruntime_web_74d14b94__.InferenceSession), ["Tensor"]: () => (__WEBPACK_EXTERNAL_MODULE_onnxruntime_web_74d14b94__.Tensor) });